import {gql} from "@apollo/client";

export const GQL_UPDATE_REPORT_CHECKS = gql`
  mutation updateReportChecks($input: ReportChecksInput!) {
    updateReportChecks(input: $input) {
        config {
          patient {
            id
          },
          patientPartnerNameDob,
          embryoNumbers,
          embryoGradeBiopsyDate,
          samplesReceivedDate,
          referringClinician,
          karyotypes,
          formatting,
          isAmended,
          isRevised,
          isPreliminary,
          isFinal
        }
    }
  }
`;

export const GQL_UPDATE_M2_REPORT_CHECKS = gql`
  mutation updateM2ReportChecks($input: M2ReportChecksInput!) {
    updateM2ReportChecks(input: $input) {
        config {
          patient {
            id
          }
          patientDemographics
          clinicReferringPhysician
          sampleInformation
          finalSampleResult
        }
    }
  }
`;

/** Does given testType array reflect PGT testing?  Return true/false */
export const isPGT = (t) => {
  if (!t) return false;
  if (!Array.isArray(t)) return false;
  return (t.includes('A') || t.includes('A+'));
}

/** Does given testType array reflect M2 testing?  Return true/false */
export const isM2 = (t) => {
  if (!t) return false;
  if (!Array.isArray(t)) return false;
  return (!t.includes('A') && !t.includes('A+'));
}
